import { Directive, ElementRef, Input, Renderer2 } from '@angular/core';
import { LyTheme } from '../../theme.service';
var LyBg = /** @class */ (function () {
    function LyBg(theme, renderer, elementRef) {
        this.theme = theme;
        this.renderer = renderer;
        this.elementRef = elementRef;
        /** Default bg */
        this._bg = 'primary';
        this.prefix = 'bg';
    }
    Object.defineProperty(LyBg.prototype, "bg", {
        get: function () {
            return this._bg;
        },
        set: function (color) {
            this._bg = color;
            var key = "" + this.prefix + (color || this._bg);
            var newStyle = this.theme.createStyle("ly-" + key, this.css.bind(this), color);
            this.theme.updateClass(this.elementRef, this.renderer, newStyle.id, this._lastClass);
            this._lastClass = newStyle.id;
        },
        enumerable: true,
        configurable: true
    });
    LyBg.prototype.css = function (bg) {
        return "background:" + this.theme.colorOf(bg) + ";";
    };
    LyBg.decorators = [
        { type: Directive, args: [{
                    selector: '[bg]'
                },] },
    ];
    /** @nocollapse */
    LyBg.ctorParameters = function () { return [
        { type: LyTheme, },
        { type: Renderer2, },
        { type: ElementRef, },
    ]; };
    LyBg.propDecorators = {
        "bg": [{ type: Input, args: ['bg',] },],
    };
    return LyBg;
}());
export { LyBg };
//# sourceMappingURL=bg.directive.js.map